import React from "react";
import './blog-details.css';
import {NavLink} from "react-router-dom";

// ....... images ......
import blogTitle from '../../assets/images/blog-details.svg'
import squareSpace from '../../assets/images/square-space.svg'
import bird from '../../assets/images/bird-dark.svg';
import linkedin from '../../assets/images/linkedin-dark.svg';
import thumb1 from "../../assets/images/thumb-1.svg";
import thumb2 from "../../assets/images/thumb-2.svg";
import thumb3 from "../../assets/images/thumb-3.svg";

function BlogDetails() {
   return (
       <div className="blog-details-page animate-page">
          <div className="blog-title-sec icon margin-b-60">
             <img src={blogTitle} alt=""/>
             <div className="title-details content-box">
                <div className="width-800">
                   <div className="title-font text-align-left margin-b-10">
                      6 inspiring promo video ideas for your business
                   </div>
                   <div className="date description">November 16, 2022</div>
                </div>
             </div>
          </div>

          <div className="content-box width-700 blog-content margin-b-60">
             <div className="description margin-b-40">
                Want to start creating promo videos for your business but stuck for ideas? We’ve curated a list of
                popular video promos that have served their businesses well.
                <a href="https://blog.hubspot.com/marketing/video-marketing" target="_blank">
                   Video marketing can boost your business
                </a>—so
                looking up video ideas before getting started is worth it. A well-made sales ad or product announcement
                can drive revenue, while a behind-the-scenes look can build interest in your community. Luckily,
                <a href="https://clipchamp.com/en/video-editor/" target="_blank">Clipchamp</a> has a library of free
                designer video templates to help you start creating when you’re ready.
                Explore how different businesses use promos to hook their viewers and learn how to plan a
                scroll-stopping video without spending big bucks.
                Video promos that won the internet
             </div>

             <div className="margin-b-40">
                <div className="small-title margin-b-20">Video promos that won the internet</div>
                <div className="sub-title rubik-medium margin-b-30">1. Squarespace</div>
                <div className="blog-details-img icon margin-b-30">
                   <img src={squareSpace} alt=""/>
                </div>
                <div className="description">
                   Pre-roll promo video ads are the perfect way to engage your audience on YouTube. In 30-seconds,
                   Squarespace’s promo video enlightened viewers about their story, challenges, and success with visuals
                   and an AI voiceover. Viewers can easily navigate how to learn more about the company with three clear
                   CTA’s at the end of the ad.
                </div>
             </div>

             <div className="">
                <div className="small-title margin-b-20">
                   How promo videos can benefit your business
                </div>
                <div className="description">
                   Viewers can turn into long-term customers from a good first impression. So creating a relevant video
                   promo for your target audience can capture prospects’ attention in seconds and convert them into
                   paying customers. Promo videos are your opportunity to introduce your brand, talk about your purpose
                   and goals, and solve pain points. Video marketing, like testimonials and explainer videos, can also
                   make your website more likely to rank on any search engine.
                </div>
             </div>


             <div className="social-media-links flex">
                <NavLink className={'icon width-17'} to={''}>
                   <img src={bird} alt=""/>
                </NavLink>
                <NavLink className={'icon width-17 margin-l-20'} to={''}>
                   <img src={linkedin} alt=""/>
                </NavLink>
             </div>
          </div>


          <div className="sec-bottom-padding-100">
             <div className="sub-heading rubik-medium text-align-center margin-b-40">More from the Floik blog</div>
             <div className="content-box width-1000">
                <ul className="blogs col-3">
                   {[
                      {id: 1, img: thumb1},
                      {id: 2, img: thumb2},
                      {id: 3, img: thumb3}].map((blog) => {
                      return (
                          <li key={blog.id}>
                             <NavLink to={'/blogs-details'}>
                                <div className="blog-img icon">
                                   <img src={blog.img} alt=""/>
                                </div>
                                <div className="blog-content">
                                   <div className="blog-title rubik-medium">6 inspiring promo video ideas for your business</div>
                                   <div className="flex font-12 user-details">
                                      <div className="author">Vartika B</div>
                                      <div className="date margin-l-30">November 16, 2022</div>
                                   </div>
                                   <div className="blog-desc">
                                      Want to start creating promo videos for your business but stuck for ideas? We’ve…
                                   </div>
                                </div>
                             </NavLink>
                          </li>
                      )
                   })
                   }
                </ul>
             </div>
          </div>


       </div>
   )
}

export default BlogDetails;
